import React from "react";
import { AsyncPaginate } from "react-select-async-paginate";

const SelectAsyncPaginate = ({
  isMulti,
  loadOptions,
  onChange,
  value,
  label,
  options
}) => {



  const colourStyles = {
    control: (styles, { data, isDisabled, isFocused, isSelected }) => ({
      ...styles,
      /*backgroundColor: "#F7F7F7",*/
      borderRadius: "none",
      border: "none",
      borderBottom: "1px solid #949494",

      boxShadow: "unset",
      color: "#81a6c9",
      paddingLeft: "0px",

      // padding: "10px 16px",
      height: "42px",
      marginBottom: "12px",
      "&:hover": {
        // borderColor: "#221F20",
        boxShadow: "unset"
      },
      "& svg": {
        color: "#85C0AB",
        fill: "#85C0AB"
      }

    }),
    valueContainer: (styles) => ({
      ...styles,
      backgroundColor: "none",
      paddingLeft: "0px"

    }),
    singleValue: (styles) => ({
      ...styles,
      color: "#221F20",
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "12px",
      paddingLeft: "0px"
    }),

    placeholder: (styles) => ({
      ...styles,
      color: "rgba(24, 32, 29, .7)",
      fontSize: "14px",
      paddingLeft: "0px"
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        cursor: isDisabled ? "not-allowed" : "default",
        fontSize: "14x",
        fontWeight: 500,
        color: isSelected || isFocused ? "#ffffff" : "#221F20",
        backgroundColor: isSelected || isFocused ? "#1da3a1" : "#ffffff",
        // paddingLeft: "0px"


      };
    }
  };



  return (
    <AsyncPaginate
      value={value}
      styles={colourStyles}
      loadOptions={loadOptions}
      options={options}
      onChange={(value) => onChange(value)}
      isMulti={isMulti}
      isClearable
      additional={{
        page: 0
      }}
      label={label}
      placeholder={label}
      className="w-100"
    />
  );
};

export default SelectAsyncPaginate;
